export const environment = {
  production: true,
  /**
   * App version, surfaced on the More page. Bump this on each
   * production deploy so users have a way to confirm they're on
   * the build you intended. Bumping is also a useful forcing
   * function for "did the SW pick up my deploy?" — if the More
   * page still shows the old number after reload, the SW didn't
   * activate yet (cache headers wrong, ngsw-config issue, etc).
   */
  appVersion: '1.0.3',
  urlBase: 'https://app.saltwaterup.com/',
  // Relative path — Apache on app.saltwaterup.com reverse-proxies
  // /apiv1/** to https://www.saltwaterup.com/apiv1/**. This means the
  // browser sees same-origin requests (no CORS preflight required) and
  // the API server sees requests coming from app.saltwaterup.com's
  // server IP rather than from end-user IPs.
  restUrlBase: '/apiv1/',
  // Same reverse-proxy pattern as restUrlBase: Apache rewrites
  // /img/fish/** to https://www.saltwaterup.com/img/fish/**. Keeps
  // image requests same-origin (cleaner for service-worker caching
  // policies) and avoids any CORS surprises.
  imageUrlBase: '/img/fish/',
  adminApiId: '541741e2-ba58-43ea-85b8-6233c7429dfd',
  adminPassword: 'x',
  anyUserPassword: 'x',
};
